<template>
  <!-- SKELETON -->
  <div v-if="isLoading" class="product product-skeleton">
    <ul class="category__header__navigation skeleton-nav">
      <li>
        <span class="skeleton-pill" style="width: 2.2rem; height: 2.2rem" />
        <span class="skeleton-pill" style="width: 2.2rem; height: 2.2rem" />
      </li>
      <li
        v-for="n in 3"
        :key="'nav' + n"
        class="d-flex align-items-center gap-2"
      >
        <span class="skeleton-pill" style="width: 2.2rem; height: 2.2rem" />
        <span
          class="skeleton-pill"
          :style="{ width: `${10 + n * 5}rem`, height: '1.6rem' }"
        />
      </li>
    </ul>

    <div class="product__header">
      <div class="product__header__item my-row">
        <!-- LEFT: IMAGE -->
        <div class="product__header__item__img_wrapper">
          <div class="product__header__item__img_wrapper__more skeleton-left">
            <!-- hlavní obrázek -->
            <div class="skeleton-box skeleton-main-image"></div>

            <!-- náhledy -->
            <div class="skeleton-thumbs">
              <div
                v-for="n in 3"
                :key="'thumb' + n"
                class="skeleton-box skeleton-thumb"
              ></div>
            </div>
          </div>
        </div>

        <!-- RIGHT: HEADER -->
        <div class="product__header__item__header">
          <h1 class="skeleton-line w-70"></h1>
          <h2 class="skeleton-line w-55 mt-2"></h2>
          <h2 class="skeleton-line w-45 mt-2"></h2>

          <div class="product__header__item__footer">
            <div class="product__header__item__footer__variants__wrapper">
              <p class="skeleton-line w-25"></p>

              <div class="product__header__item__footer__variants">
                <div
                  v-for="n in 4"
                  :key="'var' + n"
                  class="btn-gray skeleton-variant"
                >
                  <span class="skeleton-line w-60"></span>
                  <div class="home__eshop__wrapper__img_wrapper__subProducts">
                    <div class="skeleton-dot"></div>
                    <div class="skeleton-dot"></div>
                  </div>
                </div>
              </div>
            </div>

            <p class="product__header__item__footer__info skeleton-paragraph">
              <span class="skeleton-line w-90"></span>
              <span class="skeleton-line w-85 mt-1"></span>
              <span class="skeleton-line w-70 mt-1"></span>
            </p>

            <div class="home__eshop__wrapper__discounts skeleton-tags">
              <span class="btn-yellow skeleton-tag"></span>
              <span class="btn-green skeleton-tag"></span>
              <span class="btn-blue skeleton-tag"></span>
            </div>

            <div class="home__eshop__wrapper__price skeleton-price">
              <div>
                <span class="skeleton-line w-35"></span>
                <span class="skeleton-line w-25 mt-2"></span>
              </div>

              <div class="product__header__item__footer__buy skeleton-buy">
                <div class="skeleton-box skeleton-qty"></div>
                <div class="skeleton-box skeleton-btn"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /product__header__item -->
    </div>
    <!-- /product__header -->

    <div class="product__description">
      <div class="templates__wrapper skeleton-desc">
        <h2 class="skeleton-line w-35"></h2>
        <div class="skeleton-box skeleton-desc-block"></div>
        <div class="skeleton-box skeleton-desc-block mt-3"></div>
      </div>
    </div>
  </div>

  <!-- REAL PRODUCT -->
  <div class="product" v-else-if="this.products[0]">
    <ul class="category__header__navigation">
      <li>
        <router-link :to="'/'">
          <font-awesome-icon :icon="['fa', 'house']" />
        </router-link>
        <font-awesome-icon :icon="['fa', 'angle-down']" rotation="270" />
      </li>
      <template v-if="this.products[0]">
        <li
          v-for="(link, index) in this.getNavigation(
            this.products[0][0].category_path
          )"
          :key="index"
        >
          <font-awesome-icon
            v-if="index !== 0"
            :icon="['fa', 'angle-down']"
            rotation="270"
          />
          <router-link :to="'/kategorie/' + link.url_path">
            {{ link.name }}
          </router-link>
        </li>
        <li>
          <font-awesome-icon
            v-if="index !== 0"
            :icon="['fa', 'angle-down']"
            rotation="270"
          />
          <router-link :to="''">
            {{ products[0][0].name }}
          </router-link>
        </li>
      </template>
    </ul>
    <div class="product__header">
      <template v-for="product in products[0]">
        <div
          class="product__header__item my-row"
          :key="product.id"
          v-if="product.isMain === 1"
        >
          <div class="product__header__item__img_wrapper">
            <span
              v-if="product.discountPercent"
              class="home__eshop__wrapper__item_discount"
              >-{{ product.discountPercent }}%</span
            >
            <div class="product__header__item__img_wrapper__more">
              <ImagesSlider
                :images="product.image_urls"
                :imageBasePath="this.imagesBasePath"
                :productName="product.name"
                :productVariant="product.variant"
                :colorName="product.color_name"
              />
            </div>
          </div>
          <div class="product__header__item__header">
            <h1>{{ product.name }}</h1>
            <h2>{{ product.description }}</h2>

            <div class="product__header__item__footer">
              <div class="product__header__item__footer__variants__wrapper">
                <p v-if="labelText">
                  {{ labelText }}
                </p>
                <div class="product__header__item__footer__variants">
                  <template v-for="variant in this.products[0]">
                    <div
                      :class="{ active: variant.isMain == 1 }"
                      class="btn-gray"
                      v-if="variant?.color_id"
                      v-on:click="changeProduct(variant)"
                    >
                      {{ variant.color_name }}
                      <div
                        class="home__eshop__wrapper__img_wrapper__subProducts"
                      >
                        <div
                          v-if="variant.color_primary"
                          :style="{ backgroundColor: variant.color_primary }"
                        ></div>
                        <div
                          v-if="variant.color_secondary"
                          :style="{
                            backgroundColor: variant.color_secondary,
                          }"
                        ></div>
                      </div>
                    </div>
                    <template
                      v-if="!products[0][0].color_id && products[0].length > 1"
                    >
                      <div
                        :class="variant.isMain ? 'active' : ''"
                        class="btn-gray"
                        v-if="variant.parent_id !== 0"
                        v-on:click="
                          changeProduct({
                            id: variant.isMain ? 'default' : variant.id,
                          })
                        "
                      >
                        {{ variant.variant }}
                        <font-awesome-icon
                          class="btn-gray__times"
                          v-if="variant.isMain"
                          size="lg"
                          :icon="['fa', 'times']"
                        />
                      </div>
                    </template>
                  </template>
                </div>
              </div>
              <p
                v-if="product.description_sentence"
                class="product__header__item__footer__info"
              >
                {{ product.description_sentence }}
              </p>
              <div
                v-if="
                  product.discount || product.topProduct || product.newProduct
                "
                class="home__eshop__wrapper__discounts"
              >
                <span v-if="product.discount" class="btn-yellow">Akce</span>
                <span v-if="product.topProduct" class="btn-green"
                  >Top produkt</span
                >
                <span v-if="product.newProduct" class="btn-blue">Novinka</span>
              </div>
              <div class="home__eshop__wrapper__price">
                <template v-if="isMainProductActive()">
                  <div>
                    <span
                      >{{ this.products[0].length > 1 ? "od" : "" }}
                      <div v-if="getLowestPrice()['discounted']">
                        <span class="home__eshop__wrapper__price__trough"
                          >{{ getLowestPrice()["originalPrice"] }} Kč</span
                        >

                        <span class="home__eshop__wrapper__price__discount"
                          >{{ getLowestPrice()["price"] }} Kč</span
                        >
                      </div>
                      <template v-else>
                        {{ getLowestPrice()["price"] }} Kč
                      </template>
                    </span>
                  </div>
                </template>
                <template v-if="!isMainProductActive()">
                  <template v-if="product.discounted">
                    <span class="home__eshop__wrapper__price__trough"
                      >{{ product.price }} Kč</span
                    >
                    <span class="home__eshop__wrapper__price__discount"
                      >{{ product.discounted }} Kč</span
                    >
                  </template>
                  <div v-if="!product.discounted">
                    <span>
                      {{ product.price }}
                      Kč</span
                    >
                  </div>
                </template>
                <div class="product__header__item__footer__buy">
                  <vue-number-input
                    :model-value="1"
                    :min="1"
                    class="center-text"
                    v-model="amount"
                    :inputtable="false"
                    inline
                    controls
                  ></vue-number-input>
                  <button
                    :class="[
                      'btn-yellow',
                      { 'btn-yellow-disabled': isMainProductActive() },
                    ]"
                    @click="addItem(product)"
                    :disabled="isMainProductActive()"
                  >
                    {{
                      isMainProductActive()
                        ? "Vyberte variantu"
                        : "Přidat do košíku"
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="product__description">
      <template v-for="product in products[0]">
        <div
          :key="product.id"
          v-if="product.isMain === 1"
          class="templates__wrapper"
        >
          <template v-for="template in templates" :key="template.id">
            <template-product
              :product="this.parentProduct"
              :template="{ template }"
            />
          </template>
        </div>
      </template>
    </div>
  </div>

  <div v-else>Nebyl nalezen zadaný produkt</div>
</template>

<script>
import axios from "../api";
import ImagesSlider from "../components/ImagesSlider.vue";
import TemplateProduct from "../components/admin/TemplateProduct.vue";

export default {
  components: {
    ImagesSlider,
    TemplateProduct,
  },
  data() {
    return {
      productPathName: this.$route.params.productPath,
      products: [],
      categories: [],
      amount: 1,
      templates: [],
      parentProduct: null,
      isLoading: true,
      imagesBasePath: `${process.env.VUE_APP_FITMO_BACKEND_URL}/products/`,
    };
  },
  watch: {
    $route() {
      this.productPathName = this.$route.params.productPath;
      this.getCategories();
      this.getProduct().then(() => {
        return this.getTemplates();
      });
    },
  },
  methods: {
    isMainProductActive() {
      if (this.products[0].length === 1) return false;
      const item = this.products[0]?.find((item) => {
        return item?.isMain === 1 && item?.parent_id === 0;
      });
      return item?.color_id ? false : item;
    },
    async getProduct() {
      try {
        const response = await axios.get(
          "/api/product/" + this.productPathName
        );
        if (response.data[0]) {
          this.parentProduct = response.data[0].find(
            (item) => item.parent_id == 0
          );
          this.products = response.data;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    getLowestPrice() {
      let lowestDiscounted = null;
      let originalOfDiscounted = null;
      let lowestNormal = null;

      this.products[0]?.forEach((product) => {
        if (!(product.price === 0)) {
          if (product.discounted !== null) {
            if (
              lowestDiscounted === null ||
              lowestDiscounted > product.discounted
            ) {
              lowestDiscounted = product.discounted;
              originalOfDiscounted = product.price;
            }
          } else if (product.price !== null) {
            if (lowestNormal === null || lowestNormal > product.price) {
              lowestNormal = product.price;
            }
          }
        }
      });

      if (
        lowestDiscounted !== null &&
        (lowestNormal === null || lowestDiscounted < lowestNormal)
      ) {
        return {
          price: lowestDiscounted,
          originalPrice: originalOfDiscounted,
          discounted: true,
        };
      } else {
        return {
          price: lowestNormal,
          discounted: false,
        };
      }
    },
    async getTemplates() {
      if (this.products[0]) {
        const activeItem = this.products[0].find((item) => {
          return item.isMain === 1;
        });

        try {
          const response = await axios.get(
            `/api/product/${
              this.parentProduct ? this.parentProduct.id : activeItem.id
            }/getTemplates`
          );
          this.templates = response.data.map((item) => {
            item.from = "db";
            return item;
          });
          console.log(this.templates);
        } catch (error) {
          console.log(error);
        }
      }
    },
    addItem(product) {
      const storedItems = JSON.parse(localStorage.getItem("cart")) || [];
      const productId = product.product_id ?? product.id;
      const itemToUpdate = storedItems.find((item) => item.id === productId);

      let addedItem = null;

      if (itemToUpdate) {
        itemToUpdate.count += this.amount;
        addedItem = itemToUpdate;
      } else {
        const newProduct = {
          ...product,
          id: productId,
          count: this.amount,
        };
        storedItems.push(newProduct);
        addedItem = newProduct;
      }

      this.$store.commit("updateCart", storedItems);
      localStorage.setItem("cart", JSON.stringify(storedItems));
      this.$store.commit("setLastAddedItem", addedItem);
    },
    getNavigation(url) {
      let navigation = [];
      let oldElement = "";
      let index = 0;
      if (url && Object.keys(this.categories).length !== 0) {
        url.split("/").forEach((element) => {
          oldElement += "/" + element;
          if (index === 0) {
            oldElement = oldElement.substring(1);
          }
          this.categories.filter((item) => {
            if (item.url_path === oldElement) {
              navigation.push(item);
            }
          });
          index++;
        });
      }
      return navigation;
    },

    changeProduct(variant) {
      if (variant.id === "default") {
        variant.id = this.products[0].find((item) => item.parent_id === 0)?.id;
      }
      this.products[0].forEach((product) => {
        if (product.id != variant.id) {
          product.isMain = 0;
        } else {
          product.isMain = 1;
        }
      });
    },

    async getCategories() {
      const response = await axios.post("/api/categories");
      this.categories = response.data;
    },
  },

  computed: {
    labelText() {
      const product = this.products?.[0];
      if (product?.[0]?.color_id) {
        return "Barva:";
      } else if (product?.length > 1) {
        return "Varianta:";
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getProduct().then(() => {
      return this.getTemplates();
    });
  },
};
</script>

<style scoped lang="scss"></style>

<style lang="scss">
.product {
  position: relative;

  .home__eshop__wrapper__discounts span {
    font-size: 1.3rem;
  }

  .category__header__navigation {
    border: 0;

    li a,
    svg {
      color: $gray-second;
    }
  }

  .home__eshop__wrapper__item_discount {
    height: 7rem;
    width: 7rem;
    top: 2rem;
    right: 2rem;
    font-size: 1.7rem;
  }

  &__header {
    width: 90%;
    max-width: 1920px;
    margin: auto;
    padding-bottom: 3rem;

    h1 {
      font-size: 3.2rem;
      margin-top: 3rem;
    }

    h1,
    h2,
    h3 {
      text-align: left;
    }

    h2 {
      font-weight: 100;
      color: $gray;
      margin-top: 0.4rem;
      margin-bottom: 0.6rem;
      font-size: 2rem;
    }

    &__rating {
      margin: 1.6rem 0;
    }

    &__item {
      &__img_wrapper {
        margin: auto;
        position: relative;
        width: inherit;

        &__more {
          display: flex;
          gap: 1.6rem;
          margin-top: 1.6rem;

          img {
            padding: 0.6rem;
            aspect-ratio: 3 / 2;
            object-fit: contain;
          }
        }
      }

      &__footer {
        margin-right: auto;
        flex-direction: column;

        &__variants {
          display: flex;
          gap: 0.8rem;
          padding: 1px 0;
          align-items: center;
          flex-wrap: wrap;

          &__wrapper {
            padding: 1.5rem 0;

            p {
              margin-bottom: 0.3rem;
              font-size: 1.6rem;
            }
          }

          &:has(.active) {
            padding: 0;
          }

          .btn-gray {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            gap: 0.7rem;

            &:hover {
              cursor: pointer;
              background: $white;
              color: $black;
              border-color: $yellow;

              .btn-gray__times {
                background: $gray-second;
                color: $white;
              }
            }

            &.active {
              color: $black;
              border-width: 2px;
              border-color: $yellow;
            }

            &__times {
              position: absolute;
              height: 14px;
              top: -3px;
              right: -3px;
              border: 1px solid $gray-second;
              background: $white;
              border-radius: 50%;
              z-index: 2;
              color: $gray-second;
              transition: 0.2s ease all;
              aspect-ratio: 1/1;

              &:hover {
                background: $gray-second;
                color: $white;
              }
            }
          }

          .home__eshop__wrapper__img_wrapper__subProducts {
            width: 1.5rem;
            height: 1.5rem;
            margin-bottom: 0;
            border: 0;

            > div {
              width: 1.5rem;
              height: 1.5rem;
            }
          }
        }

        &__info {
          max-width: 50rem;
          margin: 1rem 0;
          line-height: 2rem;
          text-align: justify;
        }

        &__buy {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 2rem;

          button.btn-yellow {
            padding: 1rem 4rem;
            font-size: 1.8rem;
          }
        }

        .home__eshop__wrapper {
          &__price {
            display: flex;
            font-size: 2.8rem;
            gap: 1.8rem;
            margin-top: 2rem;
            align-items: flex-start;

            &__trough {
              font-size: 1.9rem;
            }
          }

          &__discounts {
            justify-content: flex-start;
          }
        }
      }

      .home__eshop__wrapper {
        &__discounts span {
          padding: 0.6rem 2rem;
        }
      }
    }
  }

  &__description {
    padding: 7rem 5%;
    background: $gray-third;
    margin: auto;
    text-align: center;

    h2 {
      text-align: left;
      padding: 3rem 0 2rem 0;
    }

    &__info {
      width: 100%;
      max-width: 35rem;

      & > div {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.product {
  &__header__item {
    position: relative;
    padding-bottom: 7rem;

    &__footer {
      display: flex;
      margin-top: 0.4rem;
      flex-wrap: wrap;
      width: 100%;

      &__info {
        display: none;
      }

      .home__eshop__wrapper {
        &__price {
          flex-direction: column;
        }

        &__discounts {
          width: 100%;
        }
      }

      &__buy {
        button.btn-yellow {
          padding: 1.2rem 4rem;
          border-radius: 2.5rem;
          bottom: 0;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-lg-min) {
  .product__header__item {
    &__img_wrapper {
      width: 70%;
      padding-right: 3rem;
    }

    &__footer {
      .home__eshop__wrapper__price {
        justify-content: flex-start;
      }
    }

    &__header {
      width: 30%;
    }
  }
}

/* ===========================
   SKELETON (MATCH DESIGN)
   =========================== */
.product-skeleton {
  /* aby to fakt vypadalo jako tvoje layout */
  .product__header {
    padding-bottom: 3rem;
  }

  .skeleton-nav {
    width: 90%;
    max-width: 1920px;
    margin: 0 auto;
    padding-top: 2rem;
    padding-bottom: 1rem;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      gap: 0.8rem;
    }
  }

  .skeleton-pill,
  .skeleton-line,
  .skeleton-box,
  .skeleton-tag,
  .skeleton-dot {
    position: relative;
    overflow: hidden;
    border-radius: 1rem;
    background: rgba(0, 0, 0, 0.06);
  }

  .skeleton-pill::after,
  .skeleton-line::after,
  .skeleton-box::after,
  .skeleton-tag::after,
  .skeleton-dot::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-120%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: skeletonShimmer 1.25s ease-in-out infinite;
  }

  @keyframes skeletonShimmer {
    100% {
      transform: translateX(120%);
    }
  }

  .skeleton-badge {
    display: inline-block;
    background: rgba(0, 0, 0, 0.06);
  }

  .skeleton-badge::after {
    border-radius: inherit;
  }

  .skeleton-left {
    flex-direction: column;
    width: 100%;
  }

  .skeleton-main-image {
    width: 100%;
    height: 40rem;
    border-radius: 2rem;
  }

  .skeleton-thumbs {
    display: flex;
    gap: 1.2rem;
    margin-top: 1.6rem;
  }

  .skeleton-thumb {
    width: 8rem;
    height: 5.2rem;
    border-radius: 1.2rem;
  }

  .skeleton-line {
    height: 1.8rem;
    border-radius: 999px;
  }

  .skeleton-line.w-90 {
    width: 90%;
  }

  .skeleton-line.w-85 {
    width: 85%;
  }

  .skeleton-line.w-70 {
    width: 70%;
  }

  .skeleton-line.w-60 {
    width: 60%;
  }

  .skeleton-line.w-55 {
    width: 55%;
  }

  .skeleton-line.w-45 {
    width: 45%;
  }

  .skeleton-line.w-35 {
    width: 35%;
  }

  .skeleton-line.w-25 {
    width: 25%;
  }

  /* aby skeleton respektoval tvoje btn-gray stylování */
  .skeleton-variant {
    min-width: 12rem;
    border-color: rgba(0, 0, 0, 0.08);
    pointer-events: none;
  }

  .skeleton-dot {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.06);
  }

  .skeleton-tags {
    margin-top: 1rem;
    gap: 0.8rem;
  }

  .skeleton-tag {
    display: inline-block;
    min-width: 7rem;
    height: 3rem;
    border-radius: 999px;
  }

  .skeleton-price {
    width: 100%;
  }

  .skeleton-buy {
    display: flex;
    gap: 2rem;
    margin-top: 1.6rem;
    align-items: center;
  }

  .skeleton-qty {
    width: 11rem;
    height: 4.2rem;
    border-radius: 2.5rem;
  }

  .skeleton-btn {
    width: 22rem;
    height: 4.6rem;
    border-radius: 2.5rem;
  }

  .skeleton-desc {
    max-width: 110rem;
    margin: 0 auto;
  }

  .skeleton-desc-block {
    width: 100%;
    height: 12rem;
    border-radius: 2rem;
  }

  /* Na mobile ať to sedí s tvojí realitou */
  @media screen and (max-width: 991px) {
    .product__header__item__img_wrapper {
      width: 100% !important;
      padding-right: 0 !important;
    }
    .product__header__item__header {
      width: 100% !important;
    }
    .skeleton-main-image {
      height: 32rem;
    }
    .skeleton-btn {
      width: 100%;
      max-width: 28rem;
    }
  }
}
</style>
